<header class="shadow">
    <nav
        class="navbar navbar-dark bg-primary navbar-expand-lg navbar-link-underline"
        aria-label="Authenticated Navbar Blue"
    >
        <div class="container-xxl nav-bar-height flex-nowrap">
            <div class="d-flex">
                @if (user()) {
                    <button
                        class="navbar-toggler"
                        type="button"
                        (click)="openMainNav(mainNavOffCanvas)"
                    >
                        <mat-icon svgIcon="menu" class="icon-lg d-xl-inline-block d-xxl-none" />
                    </button>
                }

                <a class="navbar-brand navbar-logo me-0" routerLink="/landing">
                    <div class="logo-wrapper">
                        <acm-title-logo [appName]="appName"></acm-title-logo>
                    </div>
                </a>

                <div class="d-flex align-items-center">
                    <span
                        class="d-flex badge rounded-pill text-bg-light"
                        [class.bg-danger]="isProd()"
                        [class.bg-warning]="!isProd()"
                        [title]="envDisplayName() + ' Environment'"
                    >
                        {{ envDisplayName() }} Environment
                    </span>
                </div>
            </div>

            <ul
                class="navbar-nav d-none d-lg-flex flex-grow-1 justify-content-end align-items-center"
            >
                @if (user()) {
                    @if (canReadPartner$ | async) {
                        <li class="nav-item me-0">
                            <a
                                class="nav-link user-select-none"
                                routerLink="/customers"
                                routerLinkActive="active"
                                aria-label="Customers"
                            >
                                <mat-icon
                                    svgIcon="patient_list"
                                    class="text-white"
                                    aria-hidden="true"
                                />
                            </a>
                        </li>
                    }

                    @if (canReadPartnerServices$ | async) {
                        <li class="nav-item me-0">
                            <a
                                class="nav-link user-select-none"
                                routerLink="/services"
                                routerLinkActive="active"
                                aria-label="Services"
                            >
                                <mat-icon
                                    svgIcon="dynamic_form"
                                    class="text-white"
                                    aria-hidden="true"
                                />
                            </a>
                        </li>
                    }

                    @if (featureFlags.isFlagEnabled(flags.aiChat)) {
                        <li class="nav-item me-0">
                            <button
                                type="button"
                                class="nav-link user-select-none border-0 bg-transparent"
                                aria-label="AI assistant"
                                (click)="aiChatPanel.open()"
                            >
                                <mat-icon
                                    svgIcon="smart_toy"
                                    class="text-white"
                                    aria-hidden="true"
                                />
                            </button>
                        </li>
                    }
                    @if (featureFlags.isFlagEnabled(flags.qaControls)) {
                        <li class="nav-item">
                            <button
                                type="button"
                                class="nav-link user-select-none border-0 bg-transparent"
                                aria-label="Toggle QA controls"
                                (click)="qaPanel.toggle()"
                            >
                                <mat-icon svgIcon="build" class="text-white" aria-hidden="true" />
                            </button>
                        </li>
                    }
                }
            </ul>

            <!-- user action toggle -->

            <ul class="navbar-nav d-none d-md-flex">
                @if (user(); as currentUser) {
                    <li class="nav-item me-0 dropdown" ngbDropdown>
                        <a class="nav-link user-select-none" ngbDropdownToggle>
                            <span class="badge badge-username">
                                {{ currentUser.displayInitials | uppercase }}
                            </span>
                            <!--
              FYI labcorp bootstrap maintains the desired width of a link between bold and regular fonts
              by using the data-label attribute to calculate the width when the link is not bold.
              -->
                            <span
                                class="nav-link-wrapper"
                                attr.data-label="{{ currentUser.displayName | uppercase }}"
                            >
                                <span class="nav-link-label">{{
                                    currentUser.displayName | titlecase
                                }}</span>
                            </span>
                        </a>
                        <div ngbDropdownMenu>
                            <button ngbDropdownItem (click)="logoutEvent.emit()">Sign out</button>
                        </div>
                    </li>
                }
            </ul>
        </div>
    </nav>
    <div class="p-1" [class.bg-danger]="isProd()" [class.bg-warning]="!isProd()"></div>
</header>

<!-- Main Nav Offcanvas -->
<ng-template #mainNavOffCanvas let-offcanvas>
    <div class="offcanvas-header">
        <h4 class="offcanvas-title" ngbAutofocus tabindex="-1">Navigation</h4>
        <button
            type="button"
            class="btn-close btn-close-white"
            aria-label="Close"
            (click)="offcanvas.dismiss()"
        ></button>
    </div>
    <div class="offcanvas-body m-0 p-0">
        <nav class="sidebar sidebar-dark" aria-label="Authenticated Side Navbar Blue">
            <ul class="nav flex-column">
                @if (canReadPartner$ | async) {
                    <li class="nav-item">
                        <a
                            class="nav-link user-select-none"
                            routerLink="/customers"
                            routerLinkActive="active"
                            aria-label="Customers"
                            (click)="offcanvas.dismiss()"
                        >
                            <mat-icon
                                svgIcon="patient_list"
                                class="text-white me-2"
                                aria-hidden="true"
                            />
                            <span class="nav-link-label">Customers</span>
                        </a>
                    </li>
                }

                @if (canReadPartnerServices$ | async) {
                    <li class="nav-item">
                        <a
                            class="nav-link user-select-none"
                            routerLink="/services"
                            routerLinkActive="active"
                            aria-label="Services"
                            (click)="offcanvas.dismiss()"
                        >
                            <mat-icon
                                svgIcon="dynamic_form"
                                class="text-white me-2"
                                aria-hidden="true"
                            />

                            <span class="nav-link-label">Services</span>
                        </a>
                    </li>
                }

                @if (featureFlags.isFlagEnabled(flags.aiChat)) {
                    <li class="nav-item">
                        <button
                            type="button"
                            class="nav-link user-select-none border-0 bg-transparent w-100 text-start"
                            aria-label="AI assistant"
                            (click)="aiChatPanel.open(); offcanvas.dismiss()"
                        >
                            <mat-icon
                                svgIcon="smart_toy"
                                class="text-white me-2"
                                aria-hidden="true"
                            />
                            <span class="nav-link-label">AI Assistant</span>
                        </button>
                    </li>
                }
            </ul>
        </nav>
    </div>
</ng-template>
